import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

const customShareTemplate = htmlE`
<style>
 .sharing-modal-card-container tr>td:first-child {
  min-width: 180px;
}

.sharing-modal-card-container tr>td.spanned {
  min-width: inherit;
}

.sharing-modal-card-container tr>td:first-child>label {
  width: 100%;
  text-align: right;
  display: inline-block;
}

.sharing-modal-card-container tr>td.spanned>label {
  width: auto;
  text-align: inherit;
  display: inherit;
}

.sharing-modal-card-container tr>td:nth-child(2) {
  width: 100%;
  padding-left: 10px;
  padding-top: 5px;
}

.sharing-modal-card-container .select {
  min-width: 50px;
  max-width: 200px;
}

.sharing-modal {
  overflow: auto;
}

.sharing-modal .sharing-options {
  display: flex;
  flex-wrap: wrap;
  grid-gap: 8px;
}

.sharing-modal .sharing-options span {
  white-space: nowrap;
  cursor: pointer;
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sharing-modal .sharing-options span label {
  cursor: pointer;
}

.sharing-modal .files-to-share {
  white-space: pre;
  font-family: var(--font-family);
  font-size: 14px;
  padding: 5px;
  border: 1px solid var(--border-color);
  border-radius: 4px;
  outline: none;
  box-shadow: none;
  width: 100%;
  resize: none;
}

.custom-share-is-hidden {
  display: none !important;
}

 @media only screen and (max-width: 600px) {
  .sharing-modal-card-container tr  {
    display: grid;
  }

  .sharing-modal-card-container tr>td:first-child>label {
    text-align: left;
  }
}
</style>
<div
  class="sharing-modal"
>
      <form>
        <table class="sharing-modal-card-container">
          <tr>
            <td>
              <label for="filesToShare" class="text-sm has-text-weight-semibold" data-i18n-key="sharing">
                Sharing
              </label>
            </td>
            <td>
              <div>
                <textarea class="files-to-share" rows="3" id="filesToShare" name="filesToShare" readonly>${({
                  files,
                }) => utils.textEncode(files || "")}</textarea>
              </div>
            </td>
          </tr>
          ${({ directLink, direct_link }) => {
            return `<tr class="external ${
              !directLink ? "custom-share-is-hidden" : ""
            }" config="directLink">
                <td></td>
                <td>
                  <div>
                    <input
                      ${direct_link ? "checked" : ""}
                      type="checkbox"
                      id="direct_link"
                      name="direct_link"
                    />
                    <label for="direct_link" data-i18n-key="directLink">
                    Direct link to file?
                    </label>
                  </div>
                </td>
              </tr>`;
          }}
            ${({
              shareMethod,
              shareMethodInternal,
              shareMethodExternal,
              externalUser,
            }) => {
              return `
              <tr class="${
                !shareMethod ? "custom-share-is-hidden" : ""
              }" config="shareMethod">
                <td>
                  <label class="text-sm has-text-weight-semibold" data-i18n-key="shareMethod">
                    Share Method
                  </label>
                </td>

                <td>
            <div class="is-flex is-flex-wrap-wrap">
             <div
             class="is-flex is-align-items-center mr-2 ${
               !shareMethodInternal ? "custom-share-is-hidden" : ""
             }"
             config="shareMethodInternal"
           >
             <input
               type="radio"
               id="internalShare"
               value="internal"
               name="shareType"
               ${!externalUser ? "checked" : ""}
             />
             <label
               class="text-sm ml-2"
               for="internalShare"
               data-i18n-key="internalShare"
             >
               Internal Share
             </label>
           </div>


             <div
                 class="is-flex is-align-items-center mr-2 ${
                   !shareMethodExternal ? "custom-share-is-hidden" : ""
                 }"
                 config="shareMethodExternal"
               >
                 <input
                   type="radio"
                   id="externalShare"
                   value="external"
                   name="shareType"
                  ${externalUser ? "checked" : ""}
                 />
                   <label
                   class="text-sm ml-2"
                   for="externalShare"
                   data-i18n-key="externalShare"
                 >
                   External Share
                 </label>
               </div>

                  </div>
                </td>
              </tr>
                `;
            }}

            ${({
              userNames,
              shareWindowEnableMultipleUsernameSelection,
              shareWindowEnableUsernameLookup,
            }) => {
              return `
                <tr class="internal ${
                  !userNames ? "custom-share-is-hidden" : ""
                }" config="userNames">
                <td>
                  <label
                    for="shareUsernames"
                    class="text-sm has-text-weight-semibold"
                    data-i18n-key="userNames"
                  >
                    Usernames
                  </label>
                </td>
                <td>
                  <input
                    data-validate="required"
                    data-mark-error="true"
                    data-inline-error="true"
                    name="shareUsernames"
                    class="input modal-input"
                    id="shareUsernames"
                  />

                  ${
                    shareWindowEnableMultipleUsernameSelection &&
                    shareWindowEnableUsernameLookup
                      ? `
                    <input
                      data-validate="required"
                      data-mark-error="true"
                      data-inline-error="true"
                      name="shareUsernames_multiselect"
                      class="input modal-input is-hidden"
                      id="shareUsernames-multiselect"
                     />`
                      : ""
                  }
                  <div>
                    <label
                      id="ShareWindowUsernamesLabelHelpText"
                      for="shareUsernames"
                      data-i18n-key="separateMultipleUsernamesWithCommas"
                      >(Separate multiple usernames with commas.)</label
                    >

                      ${
                        shareWindowEnableMultipleUsernameSelection &&
                        shareWindowEnableUsernameLookup
                          ? `
                        <div class="is-flex is-align-items-center mt-2">
                        <input
                          id="shareUsernameInput"
                          type="checkbox"
                          is_key="true"
                          value="multiselect"
                          checked
                          name="shareUsernameInput"
                        />
                        <label
                          class="ml-2"
                          for="shareUsernameInput"
                          data-i18n-key="selectMultipleUserQuickly"
                        >
                        Select multiple users quickly
                        </label>
                      </div>
                        `
                          : ""
                      }
                  </div>
                </td>
              </tr>
                `;
            }}

          ${({
            Permissions,
            shareUsernamePermissionsDownload,
            shareUsernamePermissionsUpload,
            shareUsernamePermissionsDelete,
            downloadPermission,
            uploadPermission,
            deletePermission,
          }) => {
            return `
              <tr class="is-hidden ${
                !Permissions ? "custom-share-is-hidden" : ""
              }" config="Permissions">
              <td>
                <label
                  for="shareUsernamePermissions"
                  class="text-sm has-text-weight-semibold"
                  data-i18n-key="permissions"
                >
                  Permissions
                </label>
              </td>
              <td>
                <div class="is-flex">

                  <div class="is-flex is-align-items-center mr-2 ${
                    !downloadPermission ? "custom-share-is-hidden" : ""
                  }">
                    <input
                      type="checkbox"
                      id="shareUsernamePermissionsDownload"
                      is_key="true"
                      value="priv_read"
                      name="shareUsernamePermissions"
                      ${shareUsernamePermissionsDownload ? "checked" : ""}
                    />
                    <label
                      class="text-sm ml-2"
                      for="shareUsernamePermissionsDownload"
                      id="ShareWindowDownloadLabelText"
                      data-i18n-key="Download"
                    >
                      Download
                    </label>
                </div>

                <div class="is-flex is-align-items-center mr-2 ${
                  !uploadPermission ? "custom-share-is-hidden" : ""
                }">
                  <input
                    type="checkbox"
                    id="shareUsernamePermissionsUpload"
                    is_key="true"
                    value="priv_write"
                    name="shareUsernamePermissions"
                    ${shareUsernamePermissionsUpload ? "checked" : ""}
                  />
                  <label
                    class="text-sm ml-2"
                    for="shareUsernamePermissionsUpload"
                    id="ShareWindowUploadLabelText"
                    data-i18n-key="Upload"
                  >
                    Upload
                  </label>
                </div>

                    <div class="is-flex is-align-items-center mr-2 ${
                      !deletePermission ? "custom-share-is-hidden" : ""
                    }">
                    <input
                      type="checkbox"
                      id="shareUsernamePermissionsDelete"
                      is_key="true"
                      value="priv_delete"
                      name="shareUsernamePermissions"
                      ${shareUsernamePermissionsDelete ? "checked" : ""}
                    />
                    <label
                      class="text-sm ml-2"
                      for="shareUsernamePermissionsDelete"
                      id="ShareWindowDeleteLabelText"
                      data-i18n-key="Delete"
                    >
                      Delete
                    </label>
                  </div>

                </div>
              </td>
            </tr>
              `;
          }}

            ${({
              shareType,
              copyType,
              referenceType,
              moveType,
              chkCopy,
              chkMove,
              chkReference,
            }) => {
              return `
                <tr class="external ${
                  !shareType ? "custom-share-is-hidden" : ""
                }" config="shareType">
                <td>
                  <label
                    id="ShareWindowShareTypeLabelText"
                    class="text-sm has-text-weight-semibold"
                    data-i18n-key="shareType"
                  >
                    Share Type
                  </label>
                </td>
                <td>
                  <div class="col-span-2">
                    <div class="is-flex">
                        <div class="is-flex is-align-items-center mr-2 ${
                          !copyType ? "custom-share-is-hidden" : ""
                        }">
                        <input
                          type="radio"
                          value="copy"
                          name="publishType"
                          id="chkCopy"
                          ${chkCopy ? "checked" : ""}
                        />
                        <label
                          class="text-sm ml-2"
                          for="chkCopy"
                          data-i18n-key="Copy"
                        >
                          Copy
                        </label>
                      </div>
                        <div class="is-flex is-align-items-center mr-2 ${
                          !referenceType ? "custom-share-is-hidden" : ""
                        }">
                        <input
                          type="radio"
                          value="reference"
                          name="publishType"
                          id="chkReference"
                          ${chkReference ? "checked" : ""}
                        />
                        <label
                          class="text-sm ml-2"
                          for="chkReference"
                          data-i18n-key="reference"
                        >
                          Reference
                        </label>
                      </div>

                        <div class="is-flex is-align-items-center mr-2 form-move advanced ${
                          !moveType ? "custom-share-is-hidden" : ""
                        }">
                        <input
                          type="radio"
                          value="move"
                          name="publishType"
                          id="chkMove"
                          ${chkMove ? "checked" : ""}
                        />
                      <label data-i18n-key="move" class="text-sm ml-2" for="chkMove"> Move </label>
                    </div>
                  </div>
                </div>
              </td>
              </tr>
                `;
            }}

             ${({ showSendEmail, sendEmail }) => {
               return `
              <tr class="sendEmail ${
                !showSendEmail ? "custom-share-is-hidden" : ""
              }"  config="sendEmail">
                <td>
                  <label class="text-sm has-text-weight-semibold" data-i18n-key="sendEmail"> Send Email </label>
                </td>
                <td>
                  <input id="sendEmail" name="sendEmail"
                    ${sendEmail ? "checked" : ""}
                     type="checkbox" />
                </td>
            </tr>`;
             }}

            ${({ expiresIn, txtdays }) => {
              return `
              <tr class="expiresIn ${
                !expiresIn ? "custom-share-is-hidden" : ""
              }" config="expiresIn">
              <td>
                <label for="txtdays" class="text-sm has-text-weight-semibold" data-i18n-key="expires">
                  Expires
                </label>
              </td>
              <td class="col-span-2 is-flex">
                <div>
                  <input
                    id="txtdays"
                    value= "${txtdays || "29"}"
                    name="txtdays"
                    class="input modal-input"
                    type="number"
                    class="w-70px"
                    min="0"
                  />
                </div>
                <label for="txtdays" class="text-sm mx-1" data-i18n-key="days">
                  Days
                </label>
                <div id="date-picker-parent">
                  <input
                    class="input modal-input"
                    name="txtDate"
                    type="date"
                    id="date-picker"
                  />
                </div>
              </td>
            </tr>
              `;
            }}

            ${({ maxUses }) => {
              return `
                <tr class="external maxUses ${
                  !maxUses ? "custom-share-is-hidden" : ""
                }" config="maxUses">
                <td>
                  <label
                    for="logins"
                    class="text-sm has-text-weight-semibold"
                    data-i18n-key="maximumNumberOfUses"
                  >
                    Maximum Number of uses
                  </label>
                </td>
                <td class="col-span-2">
                  <div class="select modal-input text-sm">
                    <select
                      id="logins"
                      name="logins"
                      class="primary-select modal-input py-0"
                    >
                      <option value="-1" data-i18n-key="unlimited">
                        Unlimited
                      </option>
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="4">4</option>
                      <option value="5">5</option>
                      <option value="6">6</option>
                      <option value="7">7</option>
                      <option value="8">8</option>
                      <option value="9">9</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                      <option value="13">13</option>
                      <option value="14">14</option>
                      <option value="15">15</option>
                      <option value="16">16</option>
                      <option value="17">17</option>
                      <option value="18">18</option>
                      <option value="19">19</option>
                      <option value="20">20</option>
                    </select>
                  </div>
                </td>
              </tr>
                `;
            }}

            ${({ shareFrom, emailFrom }) => {
              return `
                <tr class="external shareFrom ${
                  !shareFrom ? "custom-share-is-hidden" : ""
                }" config="shareFrom">
                <td>
                  <label for="emailFrom" class="text-sm has-text-weight-semibold" data-i18n-key="from">
                    From
                  </label>
                </td>
                <td class="col-span-2">
                  <input
                    data-validate="required,email"
                    data-mark-error="true"
                    data-inline-error="true"
                    id="emailFrom"
                    name="emailFrom"
                    class="input modal-input"
                    value="${utils.escapeHtmlAttr(emailFrom || "")}"
                  />
                </td>
              </tr>`;
            }}

            ${({ shareTo, emailTo }) => {
              return `
                <tr class="external shareTo ${
                  !shareTo ? "custom-share-is-hidden" : ""
                }" config="shareTo">
                <td>
                  <label for="emailTo" class="text-sm has-text-weight-semibold" data-i18n-key="to">
                    To
                  </label>
                </td>
                <td class="col-span-2">
                  <input
                    data-validate="required,multiple-emails"
                    data-mark-error="true"
                    data-inline-error="true"
                    id="emailTo"
                    name="emailTo"
                    class="input modal-input"
                    value="${utils.escapeHtmlAttr(emailTo || "")}"
                  />
                </td>
              </tr>`;
            }}

            ${({ shareCC, emailCc }) => {
              return `
                <tr class="external shareCC ${
                  !shareCC ? "custom-share-is-hidden" : ""
                }" config="shareCC">
                <td>
                  <label for="emailCc" class="text-sm has-text-weight-semibold" data-i18n-key="cc">
                    CC
                  </label>
                </td>
                <td class="col-span-2">
                  <input
                    data-validate="multiple-emails"
                    data-mark-error="true"
                    data-inline-error="true"
                    id="emailCc"
                    name="emailCc"
                    class="input modal-input"
                    value="${utils.escapeHtmlAttr(emailCc || "")}"
                  />
                </td>
              </tr>`;
            }}

            ${({ shareBCC, emailBcc }) => {
              return `
                <tr class="external shareBCC ${
                  !shareBCC ? "custom-share-is-hidden" : ""
                }" config="shareBCC">
                <td>
                  <label for="emailBcc" class="text-sm has-text-weight-semibold" data-i18n-key="bcc">
                    BCC
                  </label>
                </td>
                <td class="col-span-2">
                  <input
                    data-validate="multiple-emails"
                    data-mark-error="true"
                    data-inline-error="true"
                    id="emailBcc"
                    name="emailBcc"
                    class="input modal-input"
                    value="${utils.escapeHtmlAttr(emailBcc || "")}"
                  />
                </td>
              </tr>`;
            }}

            ${({ shareReplyTo, emailReplyTo }) => {
              return `
                <tr class="external shareReplyTo ${
                  !shareReplyTo ? "custom-share-is-hidden" : ""
                }" config="shareReplyTo">
                <td>
                  <label for="emailReplyTo" class="text-sm has-text-weight-semibold" data-i18n-key="replyTo">
                    Reply to
                  </label>
                </td>
                <td class="col-span-2">
                  <input
                    data-validate="multiple-emails"
                    data-mark-error="true"
                    data-inline-error="true"
                    id="emailReplyTo"
                    name="emailReplyTo"
                    class="input modal-input"
                    value="${utils.escapeHtmlAttr(emailReplyTo || "")}"
                  />
                </td>
              </tr>`;
            }}

            ${({ shareSubject, emailSubject }) => {
              return `
                <tr class="shareSubject ${
                  !shareSubject ? "custom-share-is-hidden" : ""
                }" config="shareSubject">
                <td>
                  <label for="emailSubject" class="text-sm has-text-weight-semibold" data-i18n-key="subject">
                    Subject
                  </label>
                </td>
                <td class="col-span-2">
                  <input
                    id="emailSubject"
                    name="emailSubject"
                    class="input modal-input"
                    value="${utils.escapeHtmlAttr(emailSubject || "")}"
                  />
                </td>
              </tr>`;
            }}

            ${({ shareBody }) => {
              return `
                <tr class="shareBody ${
                  !shareBody ? "custom-share-is-hidden" : ""
                }" config="shareBody">
                <td>
                  <label for="emailBody" class="text-sm has-text-weight-semibold" data-i18n-key="body">
                    Body
                  </label>
                </td>
                <td>
                  <div
                    id="emailBodyTemplatePanel"
                    class="select modal-input text-sm mb-2 is-hidden"
                  >
                    <select
                      class="primary-select modal-input py-0"
                      name="emailBodyTemplate"
                      id="emailBodyTemplate"
                    ></select>
                  </div>
                  <textarea
                    id="emailBody"
                    name="emailBody"
                    rows="10"
                    class="textarea w-full"
                  >A user would like to share a file with you.This link will expire on {date} at {time}\r\n\r\n{web_link}\r\n\r\n\r\n</textarea>
                </td>
              </tr>`;
            }}

            ${({ shareComments, share_comments }) => {
              return `
                <tr class="shareComments ${
                  !shareComments ? "custom-share-is-hidden" : ""
                }" config="shareComments">
                <td>
                  <label
                    for="share_comments"
                    class="text-sm has-text-weight-semibold"
                    data-i18n-key="comments"
                  >
                    Comments
                  </label>
                </td>
                <td class="col-span-2">
                  <textarea
                    id="share_comments"
                    name="share_comments"
                    rows="3"
                    class="textarea w-full"
                  >${utils.textEncode(share_comments || "")}</textarea>
                </td>
              </tr>`;
            }}

            ${({ shareKeywords, share_keywords }) => {
              return `
                <tr class="shareKeywords ${
                  !shareKeywords ? "custom-share-is-hidden" : ""
                }" config="shareKeywords">
                <td>
                  <label
                    for="share_keywords"
                    class="text-sm has-text-weight-semibold"
                    data-i18n-key="keywords"
                  >
                    Keywords
                  </label>
                </td>
                <td class="col-span-2">
                  <textarea
                    id="share_keywords"
                    name="share_keywords"
                    rows="3"
                    class="textarea w-full"
                  >${utils.textEncode(share_keywords || "")}</textarea>
                </td>
              </tr>`;
            }}

                      ${({
                        shareHideDownloadButton,
                        shareAttachThumbnail,
                        shareAttachFiles,
                        shareAdvanced,
                        shareFullAccess,
                        advanced,
                        attach,
                        attach_real,
                        hide_download,
                        fullaccess,
                      }) => {
                        return `
            <tr class="external ${
              !shareHideDownloadButton &&
              !shareAttachThumbnail &&
              !shareAttachFiles &&
              !shareAdvanced &&
              !shareFullAccess
                ? "custom-share-is-hidden"
                : ""
            }">
            <td></td>
            <td>
              <div class="sharing-options is-flex is-flex-wrap-wrap">

              <span
                class="is-flex is-align-items-center mr-2 shareAdvanced ${
                  !shareAdvanced ? "custom-share-is-hidden" : ""
                }"
                config="shareAdvanced"
              >
                <input
                  ${advanced ? "checked" : ""}
                  type="checkbox"
                  id="advanced"
                  value="advanced"
                  name="advanced"
                />
                <label
                  class="text-sm ml-2"
                  for="advanced"
                  data-i18n-key="advanced"
                >
                  Advanced
                </label>
              </span>


              <span
                class="is-flex is-align-items-center mr-2 shareAttachThumbnail ${
                  !shareAttachThumbnail ? "custom-share-is-hidden" : ""
                }"
                config="shareAttachThumbnail"
              >
                <input
                  ${attach ? "checked" : ""}
                  type="checkbox"
                  id="attach"
                  value="attach"
                  name="attach"
                />
                <label
                  class="text-sm ml-2"
                  for="attach"
                  data-i18n-key="attachThumbnail"
                >
                  Attach Thumbnail
                </label>
              </span>

                <span
                    class="is-flex is-align-items-center mr-2 shareAttachFiles ${
                      !shareAttachFiles ? "custom-share-is-hidden" : ""
                    }"
                    config="shareAttachFiles"
                  >
                    <input
                      ${attach_real ? "checked" : ""}
                      type="checkbox"
                      id="attach_real"
                      value="attach_real"
                      name="attach_real"
                    />
                    <label
                      class="text-sm ml-2"
                      for="attach_real"
                      data-i18n-key="attachFiles"
                    >
                      Attach Files
                    </label>
                  </span>

                <span
                      class="is-flex is-align-items-center mr-2 shareFullAccess ${
                        !shareFullAccess ? "custom-share-is-hidden" : ""
                      }"
                      config="shareFullAccess"
                    >
                      <input
                        type="checkbox"
                        id="fullaccess"
                        value="fullaccess"
                        name="fullaccess"
                        ${fullaccess ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        for="fullaccess"
                        data-i18n-key="fullAccess"
                      >
                        Full Access
                      </label>
                    </span>

                          <span
                      class="is-flex is-align-items-center mr-2 shareHideDownloadButton ${
                        !shareHideDownloadButton ? "custom-share-is-hidden" : ""
                      }"
                      config="shareHideDownloadButton"
                    >
                      <input
                        ${hide_download ? "checked" : ""}
                        type="checkbox"
                        id="hide_download"
                        value="hide_download"
                        name="hide_download"
                      />
                      <label
                        class="text-sm ml-2"
                        for="hide_download"
                        data-i18n-key="hideDownloadButton"
                      >
                        Hide download button
                      </label>
                    </span>

            </div>
            </td>
          </tr>
              `;
                      }}


          ${({
            sharePermissions,
            sharePermissionDownload,
            sharePermissionUpload,
            sharePermissionView,
            sharePermissionDelete,
            sharePermissionDeleteFolder,
            sharePermissionCreateFolder,
            sharePermissionRename,
            sharePermissionResumeTransfers,
            setup_delete,
            setup_deletedir,
            setup_makedir,
            setup_read,
            setup_rename,
            setup_resume,
            setup_view,
            setup_write,
          }) => {
            return `
              <tr
              class="sharePermissions ${
                !sharePermissions ? "custom-share-is-hidden" : ""
              }"
              config="sharePermissions"
            >
              <td>
                <label class="text-sm has-text-weight-semibold" data-i18n-key="permissions">
                  Permissions
                </label>
              </td>
              <td>
                <div class="is-flex is-hidden">
                    <span
                    class="is-flex is-align-items-center mr-2 shareFullAccess"
                    config="shareFullAccess"
                  >
                    <input
                      type="radio"
                      id="fullaccess"
                      value="full"
                      name="access"
                      checked
                    />
                    <label
                      class="text-sm ml-2"
                      for="fullaccess"
                      data-i18n-key="fullAccess"
                    >
                      Full Access
                    </label>
                  </span>
                  <span
                    class="is-flex is-align-items-center mr-2 advanced shareCustomPermissions"
                    config="shareCustomPermissions"
                  >
                    <input
                      type="radio"
                      id="customPermissions"
                      value="custom"
                      name="access"
                    />
                    <label
                      class="text-sm ml-2"
                      for="customPermissions"
                      data-i18n-key="customPermissions"
                    >
                      Custom Permissions
                    </label>
                  </span>
                </div>

                <div
                    class="sharing-permissions mb-2 is-flex is-flex-wrap-wrap gap-1 customPermissions"
                  >
                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionDownload ? "custom-share-is-hidden" : ""
                      }"
                      config="sharePermissionDownload"
                    >
                      <input
                        ${setup_read ? "checked" : ""}
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_read"
                      />
                      <label
                        class="text-sm ml-2"
                        for="priv_read"
                        data-i18n-key="Download"
                      >
                        Download
                      </label>
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionUpload ? "custom-share-is-hidden" : ""
                      }"
                      config="sharePermissionUpload"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_write"
                        ${setup_write ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="Upload"
                        for="priv_write"
                        >Upload</label
                      >
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionView ? "custom-share-is-hidden" : ""
                      }"
                      config="sharePermissionView"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_view"
                        ${setup_view ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="view"
                        for="priv_view"
                        >View</label
                      >
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2"
                      config="sharePermissionSlideshow"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_slideshow"
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="Slideshow"
                        for="priv_slideshow"
                      >
                        Slideshow
                      </label>
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionDelete ? "custom-share-is-hidden" : ""
                      }"
                      config="sharePermissionDelete"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_delete"
                        ${setup_delete ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="Delete"
                        for="priv_delete"
                      >
                        Delete
                      </label>
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionDeleteFolder
                          ? "custom-share-is-hidden"
                          : ""
                      }"
                      config="sharePermissionDeleteFolder"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_deletedir"
                        ${setup_deletedir ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="deleteFolder"
                        for="priv_deletedir"
                      >
                        Delete Folder
                      </label>
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionCreateFolder
                          ? "custom-share-is-hidden"
                          : ""
                      }"
                      config="sharePermissionCreateFolder"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_makedir"
                        ${setup_makedir ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="Create Folder"
                        for="priv_makedir"
                      >
                        Create Folder
                      </label>
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionRename ? "custom-share-is-hidden" : ""
                      }"
                      config="sharePermissionRename"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_rename"
                        ${setup_rename ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="Rename"
                        for="priv_rename"
                      >
                        Rename
                      </label>
                    </span>

                    <span
                      class="is-flex is-align-items-center mr-2 ${
                        !sharePermissionResumeTransfers
                          ? "custom-share-is-hidden"
                          : ""
                      }"
                      config="sharePermissionResumeTransfers"
                    >
                      <input
                        type="checkbox"
                        class="custom_priv_option"
                        id="priv_resume"
                        ${setup_resume ? "checked" : ""}
                      />
                      <label
                        class="text-sm ml-2"
                        data-i18n-key="resume"
                        for="priv_resume"
                      >
                        Resume Transfers
                      </label>
                    </span>
                  </div>

              </td>
            </tr>
                `;
          }}

            ${({ shareAlternateTempAccount, share_alt_tempaccount }) => {
              return `
              <tr
                class="shareAlternateTempAccount ${
                  !shareAlternateTempAccount ? "custom-share-is-hidden" : ""
                }"
                config="shareAlternateTempAccount"
              >
                <td>
                  <label
                    for="share_alt_tempaccount"
                    class="text-sm has-text-weight-semibold"
                    data-i18n-key="alternateTempAccount"
                  >
                    Alternate TempAccount
                  </label>
                </td>
                <td>
                  <input class="input modal-input id="share_alt_tempaccount"
                  name="share_alt_tempaccount" type="text" value="${utils.escapeHtmlAttr(
                    share_alt_tempaccount || ""
                  )}"/>
                  <div class="warning text-sm text-secondaryMain is-flex mt-1">
                    <i class="icon-exclamation-sign"></i>
                    <span data-i18n-key="alternateTempaccountInfo">
                      Use this field to set alternate TempAccount while sharing,
                      'TempAccount_' will be added as a prefix to the name used here.
                    </span>
                  </div>
                </td>
              </tr>`;
            }}

            ${({ shareUserPassConfig }) => {
              return `<tr
            class="external advanced shareUserPassConfig ${
              !shareUserPassConfig ? "custom-share-is-hidden" : ""
            }"
            config="shareUserPassConfig"
          >
            <td>
              <label class="text-sm has-text-weight-semibold" data-i18n-key="userPassword">
                Username/Password:
              </label>
            </td>
            <td class="shareUserGenerationPanel">
              <div class="shareUserPassGeneration">
                <div class="is-flex">
              <label class="is-flex is-align-items-center mr-2">
                <input
                  checked
                  name="generateUserPass"
                  type="radio"
                  id="ShareGeneratePassAuto"
                  value="auto"
                />
                <span class="text-sm ml-2" data-i18n-key="auto">Auto</span>
              </label>
                  <label class="is-flex is-align-items-center mr-2">
                    <input
                      name="generateUserPass"
                      type="radio"
                      id="ShareGeneratePass"
                      value="generate"
                    />
                    <span class="text-sm ml-2" data-i18n-key="generate"
                      >Generate</span
                    >
                  </label>
                </div>
                <div class="generate is-flex is-flex-wrap-wrap is-align-items-end mt-2 mb-2">
                  <div class="is-flex is-flex-direction-column mr-2">
                    <label data-i18n-key="username" class="text-sm">Username</label>
                    <input
                      class="input modal-input"
                      type="text"
                      id="share_generate_user"
                      placeholder="Username"
                      data-i18n-key="username"
                      data-i18n-attr-to-update="placeholder"
                      name="temp_username"
                    />
                  </div>
                  <div class="is-flex is-flex-direction-column mr-2">
                    <label data-i18n-key="password" class="text-sm">Password</label>
                    <input
                      class="input modal-input"
                      type="text"
                      id="share_generate_pass"
                      placeholder="Password"
                      data-i18n-key="password"
                      data-i18n-attr-to-update="placeholder"
                      name="temp_password"
                    />
                  </div>
                  <span class="is-flex is-align-items-center mr-2">
                    <button class="primary-button is-bordered p-1 text-xs" type="button" id="shareGenerateUserPass" data-i18n-key="generate">Generate</button>
                  </span>
                </div>
              </div>
            </td>
          </tr>`;
            }}

        </table>
      </form>
</div>`;

const resultTemplate = htmlE`
<div class="sharing-modal is-flex is-flex-direction-column gap-3">

<div class="is-flex">
<label for="filesToShare" class="text-sm has-text-weight-semibold" data-i18n-key="sharing">
Sharing
</label>
      <span class="ml-1 mr-1"> : </span>
     <textarea class="files-to-share" rows="3" id="filesToShare" name="filesToShare" readonly>${({
       files,
     }) => utils.textEncode(files || "")}</textarea>
    </div>

${({ username, password }) => {
  return `
    <div>
      <label class="text-sm has-text-weight-semibold" data-i18n-key="username">username</label>
      <span> : </span>
      <span>${utils.textEncode(username || "")}</span>
    </div>

    <div>
        <label class="text-sm has-text-weight-semibold" data-i18n-key="password">password</label>
        <span> : </span>
        <span id="customShareResultPassword">${utils.textEncode(
          password || ""
        )}</span>
    </div>
`;
}}

${({ url, shareUsernames }) => {
  if (!shareUsernames) {
    return `
    <div class="word-break-all">
      <label class="text-sm has-text-weight-semibold" data-i18n-key="link">link</label>
      <span> : </span>
      <span id="customShareResultURL">${utils.textEncode(url || "")}</span>
    </div>`;
  }
  return ``;
}}

${({ shareUsernames }) => {
  if (shareUsernames) {
    return `
  <div>
    <p class="text-primaryMain">The following users have now been granted access to the shared items.</p>
    <p class="text-primaryMain mt-2">${utils.textEncode(shareUsernames)}</p>
  </div>
`;
  }
}}
</div>`;

const errorResponseTemplate = htmlE`
${({ errorMessage }) => {
  return `<p class="text-error text-sm whitespace-preline">${utils.textEncode(
    errorMessage || ""
  )}</p>`;
}}
`;

export { errorResponseTemplate, resultTemplate, customShareTemplate };
